/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, computed } from '@vue/composition-api';
import { Dialog } from '../../dialog/index.js';
import TImageItem from './ImageItem.js';
import TImageViewerUtils from './ImageViewerUtils.js';
import { usePrefixClass } from '../../hooks/useConfig.js';
import { useTNodeJSX } from '../../hooks/tnode.js';
import props from '../props.js';
import '../../dialog/dialog.js';
import 'lodash/isNumber';
import 'lodash/throttle';
import 'tdesign-icons-vue';
import '../../button/index.js';
import '../../button/button.js';
import '../../loading/index.js';
import '../../loading/directive.js';
import 'lodash/isObject';
import 'lodash/mapKeys';
import 'lodash/isEqual';
import '../../loading/plugin.js';
import 'vue';
import '../../loading/loading.js';
import '../../loading/icon/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/isString';
import 'lodash/isNull';
import 'lodash/isUndefined';
import 'lodash/isArray';
import '../../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../../config-provider/context.js';
import 'lodash/merge';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../../_chunks/dep-9849f16c.js';
import '../../config-provider/type.js';
import '../../utils/mixins.js';
import '../../utils/dom.js';
import 'raf';
import '../../utils/easing.js';
import '../../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../utils/transfer-dom.js';
import '../../loading/props.js';
import '../../config.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../loading/type.js';
import '../../button/props.js';
import '../../utils/ripple.js';
import '../../button/type.js';
import '../../dialog/actions.js';
import '../../_chunks/dep-1461d230.js';
import '../../dialog/props.js';
import '../../utils/event.js';
import '../../utils/helper.js';
import '../../hooks/useDestroyOnClose.js';
import '../../dialog/stack.js';
import '../../_common/js/utils/getScrollbarWidth.js';
import '../../dialog/type.js';
import '../../dialog/plugin.js';
import '../../config-provider/config-provider.js';
import 'lodash/cloneDeep';
import '../hooks.js';
import '../../hooks/index.js';
import '../../hooks/slots.js';
import '../../hooks/useCommonClassName.js';
import '../../config-provider/useConfig.js';
import '../../hooks/useDefaultValue.js';
import '../../hooks/useElementLazyRender.js';
import '../../_common/js/utils/observe.js';
import '../../hooks/useFormDisabled.js';
import '../../hooks/useGlobalIcon.js';
import '../../hooks/useLazyLoad.js';
import '../../hooks/useResizeObserver.js';
import '../../hooks/useVirtualScrollNew.js';
import '../../hooks/useVModel.js';
import '../../hooks/useImagePreviewUrl.js';
import '../../_common/js/upload/utils.js';
import '../../_common/js/log/log.js';
import './ImageModalIcon.js';
import 'lodash/isEmpty';
import 'lodash/isFunction';
import '../../hooks/render-tnode.js';
import '../../tooltip/index.js';
import '../../tooltip/tooltip.js';
import '../../tooltip/props.js';
import '../../popup/props.js';
import '../../popup/popup.js';
import '@popperjs/core';
import 'lodash/debounce';
import '../../popup/container.js';
import '../../popup/utils.js';
import '../../utils/map-props.js';
import '../../tooltip/type.js';
import '../utils.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  zIndex: Number,
  visible: Boolean,
  index: Number,
  images: props.images,
  scale: Number,
  rotate: Number,
  mirror: Number,
  currentImage: {
    type: Object,
    "default": function _default() {
      return {};
    }
  },
  rotateHandler: Function,
  zoomInHandler: Function,
  zoomOutHandler: Function,
  mirrorHandler: Function,
  resetHandler: Function,
  closeHandler: props.onClose,
  draggable: {
    type: Boolean,
    "default": true
  },
  viewerScale: {
    type: Object,
    "default": function _default() {
      return {};
    }
  },
  showOverlay: Boolean,
  closeBtn: props.closeBtn
};
var TImageViewerModal = defineComponent({
  name: "TImageViewerModal",
  props: _objectSpread({}, defaultProps),
  setup: function setup(props2) {
    var classPrefix = usePrefixClass();
    var renderJSX = useTNodeJSX();
    var style = computed(function () {
      return {
        minWidth: props2.viewerScale.minWidth,
        minHeight: props2.viewerScale.minHeight
      };
    });
    return {
      classPrefix: classPrefix,
      renderJSX: renderJSX,
      style: style
    };
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    return h(Dialog, {
      "attrs": {
        "destroyOnClose": true,
        "visible": this.visible,
        "placement": "center",
        "mode": "modeless",
        "width": 1e3,
        "cancelBtn": null,
        "confirmBtn": null,
        "draggable": this.draggable,
        "zIndex": this.zIndex,
        "showOverlay": this.showOverlay,
        "header": this.title,
        "footer": function footer() {
          return h("div", {
            "class": "".concat(_this.classPrefix, "-image-viewer-mini__footer")
          }, [h(TImageViewerUtils, {
            "attrs": {
              "zoomInHandler": _this.zoomInHandler,
              "zoomOutHandler": _this.zoomOutHandler,
              "scale": _this.scale,
              "currentImage": _this.currentImage,
              "rotateHandler": _this.rotateHandler,
              "mirrorHandler": _this.mirrorHandler,
              "resetHandler": _this.resetHandler
            }
          })]);
        }
      },
      "on": {
        "close": this.closeHandler
      },
      "class": "".concat(this.classPrefix, "-image-viewer__dialog")
    }, [h("div", {
      "class": "".concat(this.classPrefix, "-image-viewer-mini__content"),
      "style": this.style
    }, [h(TImageItem, {
      "attrs": {
        "rotate": this.rotate,
        "scale": this.scale,
        "mirror": this.mirror,
        "src": this.currentImage.mainImage,
        "placementSrc": this.currentImage.thumbnail
      }
    })])]);
  }
});

export { TImageViewerModal as default };
//# sourceMappingURL=ImageViewerModal.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/image-viewer/base/ImageViewerModal.js
// module id = null
// module chunks = 